import React from 'react';
import { SectionInstance } from '../types';

const HEIGHTS: Record<string, number> = {
  small:  48,
  medium: 80,
  large:  120,
};

const DividerWave: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const variant  = c.variant  || 'wave';
  const color    = c.color    || 'var(--brand-primary, #1a365d)';
  const flip     = c.flip     === true || c.flip === 'true';
  const heightPx = HEIGHTS[c.height || 'medium'] || 80;

  // SVG paths for a viewBox of "0 0 1440 <height>"
  const getPath = (v: string, h: number): string => {
    switch (v) {
      case 'angle':
        return `M0,${h} L1440,0 L1440,${h} Z`;
      case 'curve':
        return `M0,${h} Q720,0 1440,${h} L1440,${h} L0,${h} Z`;
      case 'zigzag':
        return `M0,${h} L180,0 L360,${h} L540,0 L720,${h} L900,0 L1080,${h} L1260,0 L1440,${h} L1440,${h} L0,${h} Z`;
      case 'wave':
      default:
        return `M0,${h/2} C240,${h*1.2} 480,${-h*0.2} 720,${h/2} C960,${h*1.2} 1200,${-h*0.2} 1440,${h/2} L1440,${h} L0,${h} Z`;
    }
  };

  const path = getPath(variant, heightPx);

  return (
    <div
      className="sb-render sb-render-divider-wave"
      style={{
        lineHeight: 0,
        overflow: 'hidden',
        transform: flip ? 'scaleY(-1)' : undefined,
      }}
      aria-hidden="true"
    >
      <svg
        viewBox={`0 0 1440 ${heightPx}`}
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block', width: '100%', height: heightPx }}
      >
        <path d={path} fill={color} />
      </svg>
    </div>
  );
};

export default DividerWave;
